/* @jsx m */
import m from 'mithril';

import Icon from './Icon.jsx';

export default function ScrollBanner() {
  return {
    view: (vnode) => {
      const classes = ['scroll-banner'];
      if(!vnode.attrs.show) classes.push('hide');
      return (
        <div class={classes.join(' ')}>
         You have unread messages
        </div>
      );
    },
  }
}
